import styled from 'styled-components';

export const AnchorLike = styled.span`
  color: #5281ff;
  background: none;
  border: none;
  cursor: pointer;
  display: inline;
  height: auto;
  width: auto;
  padding: 0;
  margin: 0;
`;
